export class AreaKmlSchemas {
    Type:string = "";
    Name:string = "";

    constructor (type: string, name:string){
        this.Type = type;
        this.Name = name;
    }
}
